/**
 * Constants for referrals feature
 */
export const REFERRAL_PAGE_SIZE = 10;
export const REFERRAL_STALE_TIME = 5 * 60 * 1000; // 5 minutes

/**
 * Referral commission rates
 */
export const REFERRAL_RATES = {
    COMMISSION_PERCENTAGE: 20, // 20% commission
    ESTIMATED_MONTHLY_PER_REFERRAL: 6, // $6 per referral per month
} as const;

/**
 * Referral link configuration
 */
export const REFERRAL_CONFIG = {
    BASE_URL: {
        PRODUCTION: 'https://join.stan.store',
        STAGING: 'https://join.staging.stan.store',
    },
} as const;

/**
 * Subscription status values
 */
export const SUBSCRIPTION_STATUS = {
    INACTIVE: 0,
    ACTIVE: 1,
} as const;

/**
 * Referral sharing methods for how-to section
 */
export const REFERRAL_METHODS = [
    {
        number: 1,
        title: 'Add to Your Store',
        description: 'Add your referral code in a click with our built-in tool.',
        image: 'https://admin.staging.stan.store/images/referrals/referral-1.png',
        alt: 'Profile page with social media links',
    },
    {
        number: 2,
        title: 'Mention Stan',
        description: "Share the experience you've had on Stan with your audience!",
        image: 'https://admin.staging.stan.store/images/referrals/referral-2.png',
        alt: 'Instagram profile with Stan link',
    },
    {
        number: 3,
        title: 'Add to Your Email Signature',
        description: 'Add your code to your email signature for an always-on source.',
        image: 'https://admin.staging.stan.store/images/referrals/referral-3.png',
        alt: 'Email client with referral link',
    },
] as const;
